module.exports = __webpack_public_path__ + "static/img/logo_h.642d3a3b.png";